import { Callout } from "../components/Callout.js";
import { ScreenshotBox } from "../components/ScreenshotBox.js";

export const meta = {
  title: "送信履歴",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <p>
        過去の書類送信履歴は「<strong>送信ログ</strong>」タブで一覧確認できます。
        ステータスや日付で絞り込み、CSV エクスポートも可能。
      </p>

      <ScreenshotBox src="/guide/screenshots/send-logs-1.png" caption="送信ログ画面" />

      <h2>表示項目</h2>
      <ul>
        <li>HubSpot レコード ID</li>
        <li>オブジェクト（取引 / 会社 / コンタクト等）</li>
        <li>クラウドサインステータス</li>
        <li>宛先数</li>
        <li>送信日時</li>
      </ul>

      <h2>フィルター</h2>
      <p>画面上部のフィルター UI で絞り込み:</p>
      <ul>
        <li><strong>ステータス</strong>: 下書き / 送信済み / 顧客署名済 / 締結完了 / 却下 / 期限切れ</li>
        <li><strong>オブジェクト</strong>: 取引 / 会社 / コンタクト</li>
        <li><strong>日付範囲</strong>: from – to 指定</li>
        <li><strong>レコード ID 検索</strong>: HubSpot のレコード ID で絞り込み</li>
      </ul>

      <h2>ダウンロード</h2>
      <h3>CSV エクスポート</h3>
      <p>
        現在のフィルター条件に合致するログを CSV ファイルとしてダウンロード。
        会計処理や月次レポート作成に便利。
      </p>

      <h3>締結済 PDF・合意締結証明書のダウンロード</h3>
      <p>
        ステータスが「締結」のログは、PDF / 合意締結証明書のダウンロードボタンが
        有効になります。クラウドサインから直接取得して提供します。
      </p>

      <Callout type="info" title="PDF はクラウドサインに存在する書類のみ">
        クラウドサイン側で削除された書類は当サービス経由でも取得できません。
        その場合、当サービスのステータスは <code>not_found</code> 表示になります。
      </Callout>

      <h2>書類の取り消し（キャンセル）</h2>
      <p>
        ステータスが「送信済み」の書類は、当サービス上から取り消し操作ができます。
      </p>

      <Callout type="warning" title="取り消し後はステータスが変わる">
        取り消し成功後、クラウドサインのステータスは「却下」になり、HubSpot にも
        次回の同期タイミングで「却下」として HubSpot にも反映されます。
      </Callout>

      <h2>取得不可（not_found）について</h2>
      <p>
        ステータス欄に「取得不可」と表示されているログは、クラウドサイン側で
        書類が見つからない状態を意味します。原因として:
      </p>
      <ul>
        <li>クラウドサイン側で書類が削除された</li>
        <li>送信時の Client ID が無効化された</li>
        <li>送信時と異なる環境（本番 / sandbox）の Client ID をデフォルトにしている</li>
      </ul>
      <p>
        このログ自体は履歴として残ります。
      </p>
    </>
  );
}
